"use client";
import { TObituaryFull } from "@/types/obituary";
import "yet-another-react-lightbox/styles.css";
const breakpoints = [1080, 640, 384, 256, 128];

const BioComponent = ({ bio }: TObituaryFull) => {
  return (
    <section className="w-full bg-secondary-200 px-2 py-12">
      <div className="container mx-auto flex flex-col gap-4">
        {/* <h3 className="mx-auto text-center">Biography</h3> */}
        <span
          className="secondary secondary-container mx-auto flex max-w-6xl flex-col gap-1 text-center text-lg"
          id="bio-container"
          dangerouslySetInnerHTML={{ __html: bio }}
        />
      </div>
    </section>
  );
};

export default BioComponent;
